import React from "react";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { Container, Row, Col, Button } from "reactstrap";
import DatePicker from "../../common/DatePicker";
import moment from "moment";
import Reform from "@franleplant/reform";
import { FormErrors } from "@franleplant/reform/types";

interface Props {
  id: number;
  updateFecha: (id: number, fecha: string) => any;
}

interface State {
  fields: {
    fecha: null;
  };
  errors: FormErrors;
}

class UpdateFechaModal extends React.Component<Props, State> {
  re = Reform.reactMixins.objectMixin(this);

  state = {
    fields: {
      fecha: null
    },
    errors: {}
  };

  validationRules = {
    fecha: { required: true, date: true }
  };

  validationMessages = {
    required: () => `Obligatorio`,
    date: () => "Fecha inválida",
    default: () => `Inválido`
  };

  setFecha = fieldName => {
    return event => {
      const date = moment(event).format("YYYY-MM-DD");
      this.setState(state => {
        const fields = {
          ...state.fields,
          [fieldName]: date
        };
        return { ...state, error: {}, fields };
      });
    };
  };

  onClickSubmit = () => {
    if (this.re.validateFormFromState()) {
      const { fecha } = { ...this.state.fields };
      this.props.updateFecha(this.props.id, fecha);
    }
  };

  validState = () => {
    const fields = { ...this.state.fields };
    return fields.fecha;
  };

  render() {
    return (
      <Container>
        <Row>
          <Col>
            <DatePicker
              xs={6}
              md={2}
              lg={2}
              label="Fecha de Actualización"
              name="fechaMovimiento"
              id="fechaMovimiento"
              selected={this.state.fields.fecha}
              onChange={this.setFecha("fecha")}
              errors={this.re.mapFieldErrors("fecha")}
            />
            {/*<BaseInput
              label="Fecha de Actualización"
              name="fechaMovimiento"
              type="text"
              id="fechaMovimiento"
              placeholder="Fecha de Actualización"
              value={this.state.fields.fecha}
              onChange={this.setFecha}
              errors={this.re.mapFieldErrors("fecha")}
            />*/}
          </Col>
          <Col xs={3} md={4}>
            <Button
              className={`mt-4 ${s.buttonMarginTop} ${s.primaryButton}`}
              onClick={this.onClickSubmit}
              disabled={!this.validState()}
              block
              style={{ height: "2rem" }}
            >
              Actualizar Fecha
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withStyles(s)(UpdateFechaModal);
